<template>
	<div class="col" gutter="20">
		<Title title="DFC 挑戰資源包管理" />
		<SearchBar :searchText="searchText" @search="handleSearch" placeholder="名稱" />

		<div class="row" align-x="between" align-y="center">
			<div class="row" align-y="center" gutter="20">
				<el-button @click="openDialog()" type="primary" icon="el-icon-plus" size="mini">上傳 DFC 挑戰資源包</el-button>
				<el-radio-group v-model="publishStatus" @change="statusChange" size="mini">
					<el-radio-button label="">全部</el-radio-button>
					<el-radio-button label="true">已發布</el-radio-button>
					<el-radio-button label="false">未發佈</el-radio-button>
				</el-radio-group>
				<el-button @click="handleDownload()" style="background-color: #B3CC65;color: #fff;" size="mini">下載點擊追蹤資料</el-button>
			</div>
			<el-pagination v-if="dfcDataList.total > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="dfcDataList.total" />
		</div>
		<el-table :data="dfcDataList.list">
			<el-table-column label="名稱" prop="title"></el-table-column>
			<el-table-column label="簡介" prop="brief">
				<pre slot-scope="{row}">{{row.brief}}</pre>
			</el-table-column>
			<el-table-column label="狀態" align="center" width="150">
				<template slot-scope="{row}">
					<el-tag :type="row.published ? 'success' : 'info'">
						{{row.published ? '發布' : '草稿'}}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="點擊次數" align="center" width="150">
				<pre slot-scope="{row}">{{row.count}}</pre>
			</el-table-column>
			<el-table-column label="實際點擊人數" align="center" width="150">
				<pre slot-scope="{row}">{{row.usersCount}}</pre>
			</el-table-column>
			<el-table-column label="帳號追蹤" align="center" width="150">
				<template slot-scope="{row}">
					<el-button @click="viewAccountTracking(row)" type="text">查看</el-button>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="150">
				<template slot-scope="{row}">
					<el-button @click="openDialog(row)" type="text">編輯</el-button>
					<el-button @click="handleDatete(row.id)" icon="el-icon-delete" type="text" class="color-danger"></el-button>
				</template>
			</el-table-column>
		</el-table>

		<el-dialog title="上傳 DFC 挑戰資源包" :visible.sync="dialogVisible" v-loading.fullscreen.lock="loading" @close="closeDialog()" :close-on-click-modal="false" :close-on-press-escape="false">
			<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-position="left" label-width="80px">
				<el-form-item label="名稱" prop="title">
					<el-input v-model="ruleForm.title"></el-input>
				</el-form-item>
				<el-form-item label="簡介" prop="brief">
					<el-input v-model="ruleForm.brief" type="textarea" :autosize="{minRows: 3}" placeholder="30字以內"></el-input>
				</el-form-item>
				<el-form-item label="連結" prop="link">
					<el-input v-model="ruleForm.link"></el-input>
				</el-form-item>
				<el-form-item>
					<div class="row" align-x="right">
						<el-button type="info" @click="handleSubmit(false)">暫存為草稿</el-button>
						<el-button type="success" @click="handleSubmit(true)">發布</el-button>
					</div>
				</el-form-item>
			</el-form>
			<el-dialog :visible.sync="innerDialogVisible" append-to-body>
				<img :src="previewURL" alt="" width="100%" />
			</el-dialog>
		</el-dialog>

		<!-- 隱藏的表格用於導出Excel -->
		<table ref="exportTable" style="display: none;">
			<thead>
				<tr>
					<th>名稱</th>
					<th>簡介</th>
					<th>連結</th>
					<th>點擊次數</th>
					<th>實際點擊人數</th>
					<th>狀態</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="item in dfcDataList.list" :key="item.id">
					<td>{{ item.title }}</td>
					<td>{{ item.brief }}</td>
					<td>{{ item.link }}</td>
					<td>{{ item.count }}</td>
					<td>{{ item.usersCount }}</td>
					<td>{{ item.published ? '已發布' : '未發佈' }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import Title from "@/components/backendManage/Title";
import SearchBar from "@/components/backendManage/SearchBar";
import { mapActions, mapState } from "vuex";
import API from "@/api";
import _ from "lodash";
import xlsxMixin from "@/libs/xlsx";

function fields() {
	return {
		title: '',
		brief: '',
		link: '',
	}
}

export default {
	components: { Title, SearchBar },
	mixins: [xlsxMixin],
	data() {
		return {
			isNewPost: true,
			loading: false,
			dialogVisible: false,
			innerDialogVisible: false,
			previewURL: '',
			currentPage: 1,
			pageSize: 10,
			searchText: "",
			publishStatus: '',
			ruleForm: fields(),
			rules: {
				title: [{ required: true, message: '名稱', trigger: 'blur' }],
				brief: [{ required: true, message: '簡介', trigger: 'blur' }],
				link: [{ required: true, message: '連結', trigger: 'blur' }],
			}
		};
	},
	computed: {
		...mapState('DFCResource', ['dfcDataList']),
		query: {
			get() {
				return {
					page: this.currentPage,
					size: this.pageSize,
					text: this.searchText,
					published: this.publishStatus
				}
			},
			set({ page, size, text, published }) {
				if (page) this.currentPage = Number(page);
				if (size) this.pageSize = Number(size);
				if (text) this.searchText = text;
				if (published) this.publishStatus = JSON.parse(published);
			}
		}
	},
	watch: {
		async query(val) {
			await this.getDFCResourceList(val);
			this.$router.replace({ query: this.query });
		}
	},
	methods: {
		...mapActions('DFCResource', ['getDFCResourceList', 'createDFCResource', 'updateDFCResource', 'deleteDFCResource']),
		init() {
			if (this.$route.query) this.query = this.$route.query;
		},
		handleSearch(text) {
			this.searchText = text;
			this.currentPage = 1;
		},
		handleSizeChange(size) {
			this.pageSize = size;
			this.currentPage = 1;
		},
		handleCurrentChange(page) {
			this.currentPage = page;
		},
		statusChange(status) {
			this.currentPage = 1;
		},
		resetForm() {
			this.$refs['ruleForm'].clearValidate();
			this.ruleForm = fields();
		},
		openDialog(data) {
			if (data) this.ruleForm = data;
			this.isNewPost = data ? false : true;
			this.dialogVisible = true;
		},
		closeDialog() {
			this.resetForm();
			this.dialogVisible = false;
		},
		handleSubmit(published) {
			this.$refs['ruleForm'].validate(async valid => {
				if (valid) {
					_.assign(this.ruleForm, { published });
					try {
						if (this.isNewPost) {
							await this.createDFCResource({ query: this.query, data: this.ruleForm });
						} else {
							await this.updateDFCResource({ query: this.query, data: this.ruleForm });
						}
						this.closeDialog();
					} catch (e) {
						this.$message.error(e);
					}
				}
			})
		},
		handleDatete(id) {
			this.$confirm('確定刪除？', '提示', {
				confirmButtonText: '確定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.deleteDFCResource({ query: this.query, id });
				this.$message({
					type: 'success',
					message: '刪除成功！'
				});
			}).catch(() => { });
		},
		handlePreview(file) {
			this.previewURL = file.url;
			this.innerDialogVisible = true;
		},
		viewAccountTracking(row) {
			// 導航至帳號追蹤頁面
			this.$router.push(`/backend-manage/challenge-resource-package/${row.id}`);
		},
		async handleDownload() {
			try {
				this.loading = true;
				// 獲取所有DFC挑戰資源包數據（不分頁）
				const response = await API.GetDFCResourceList({ size: 9999 });
				const allResources = response.data.list;
				
				// 更新隱藏表格的數據
				this.dfcDataList.list = allResources;
				
				// 等待DOM更新
				await this.$nextTick();
				
				// 使用xlsx mixin導出Excel
				await this.saveAsXLSX(this.$refs.exportTable, 'DFC 挑戰資源包管理_點擊追蹤資料.xlsx');
				
				this.$message({
					type: 'success',
					message: '下載成功！'
				});
			} catch (error) {
				this.$message.error('下載失敗：' + error.message);
				console.error(error);
			} finally {
				this.loading = false;
				// 恢復原始數據
				await this.getDFCResourceList(this.query);
			}
		}
	},
	async created() {
		this.init();
		await this.getDFCResourceList(this.query);
	}
};
</script>

<style lang="scss" scoped>
</style>
